import { useDispatch, useSelector } from 'react-redux';

export const useAspDispatch = useDispatch;
export const useAspSelector = useSelector;
